import { useTranslation } from '@/features/shared/composables/useTranslation'
import { PERMISSIONS } from '@/features/shared/constants/permissions'

const t = useTranslation()

export const brandsRoutes = [
  {
    path: 'brands',
    name: 'Entities',
    component: () => import('@/features/brands/views/Brands.vue'),
    meta: {
      title: `${t('brands')} | Pour Now`,
      mainRouteName: 'Entities',
      permissionIdentifiers: [PERMISSIONS.CAN_VIEW_ACCOUNT],
    },
  },
  {
    path: 'brands/new',
    name: 'AddBrand',
    component: () => import('@/features/brands/views/AddEditBrand.vue'),
    meta: {
      title: `${t('add_new_brand')} | Pour Now`,
      mainRouteName: 'Entities',
      permissionIdentifiers: [PERMISSIONS.CAN_CREATE_ACCOUNT],
    },
  },
  {
    path: 'brands/:brandId',
    name: 'EditBrand',
    component: () => import('@/features/brands/views/AddEditBrand.vue'),
    meta: {
      title: `${t('edit_brand')} | Pour Now`,
      mainRouteName: 'Entities',
      permissionIdentifiers: [PERMISSIONS.CAN_UPDATE_ACCOUNT],
    },
  },
]
